// extracted by mini-css-extract-plugin
export var labelTitleStyle = "search_instant_dropdown_result-module--labelTitleStyle--waL93";
export var searchResultItemStyle = "search_instant_dropdown_result-module--searchResultItemStyle--v7WIw";
export var searchResultItemTitleStyle = "search_instant_dropdown_result-module--searchResultItemTitleStyle--E+Fo8";